import { setNotification } from "features/Notification/notificationSlice";
import { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";
import { socket } from "../../../socket";
import SWoImportOptions from "./SWoImportOptions";

export default function ImportSWO({
  selected,
  refreshFunc,
  setSelected,
  showModal,
}) {
  /*   All States
   ********************************************* */
  const dispatch = useDispatch();

  const [isImporting, setIsImporting] = useState(false);

  const [updatedSWo, setUpdatedSWo] = useState(selected);

  const [isConnected, setIsConnected] = useState(false);
  const [importStatuses, setImportStatuses] = useState([
    { id: 1, status: "Importing work order fields...", isCompleted: false },
    { id: 2, status: "Copying work order products...", isCompleted: false },
    { id: 3, status: "Importing work order files...", isCompleted: false },
  ]);

  const [loading, setLoading] = useState(false);

  /*   All Functions
   ********************************************* */
  const loadingOn = () => {
    setLoading(true);
  };
  const loadingOff = () => {
    setLoading(false);
  };

  const handleImportSWo = async () => {
    try {
      loadingOn();
      setIsImporting(true);
      const { data } = await API.post("/m-order", updatedSWo, {
        headers: authHeader(),
      });
      if (data?.success) {
        await refreshFunc();
        setSelected(null);
        setIsImporting(false);
        showModal(false);
        dispatch(
          setNotification({
            message: "Work order imported successfully",
            type: "success",
          })
        );
      }
      if (!data?.success) {
        dispatch(
          setNotification({
            message: data?.message || "Failed to import work order",
            type: "error",
          })
        );
        setIsImporting(false);
      }
      loadingOff();
    } catch (err) {
      loadingOff();
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    function onConnect() {
      console.log("Connecting to back-end...");

      setIsConnected(true);
      console.log("back-end connected");
    }

    function onDisconnect() {
      setIsConnected(false);
    }

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);

    // check if socket is connected
    if (socket.connected) {
      setIsConnected(true);
    } else {
      setIsConnected(false);
    }

    /** Sockets to listen to:
     * "m-order-copied"
     * "m-order-products-copied"
     * "m-order-files-copied"
     */
    socket.on("m-order-copied", (data) => {
      console.log("Work order fields imported successfully", data);
      setImportStatuses((prevStatuses) =>
        prevStatuses.map((status) =>
          status.id === 1 ? { ...status, isCompleted: true } : status
        )
      );
    });

    socket.on("m-order-products-copied", (data) => {
      console.log("Work order products copied successfully", data);
      setImportStatuses((prevStatuses) =>
        prevStatuses.map((status) =>
          status.id === 2 ? { ...status, isCompleted: true } : status
        )
      );
    });

    socket.on("m-order-files-copied", (data) => {
      console.log("Work order files copied successfully", data);
      setImportStatuses((prevStatuses) =>
        prevStatuses.map((status) =>
          status.id === 3 ? { ...status, isCompleted: true } : status
        )
      );
    });

    return () => {
      // if (
      //   user?.permissions?.includes('sms_view') ||
      //   user?.permissions?.includes('sms_send') ||
      //   user?.roles === 'admin'
      // ) {
      //   getUnreadSmsCount();
      // }
      // socket.off("connect", onConnect);
      // socket.off("disconnect", onDisconnect);
      // socket.off("newSms", handleNewSms);
      // socket.off("mockups-app", getUnreadMockupCount);
    };
  }, [socket]);

  // useEffect(() => {
  //   if (!isConnected || !selected) {
  //     return;
  //   }
  //   // handleImportSWo();
  // }, [isConnected, selected]);

  if (!isConnected || !selected) {
    return <Spinner />;
  }
  return (
    <div>
      {!isImporting && (
        <SWoImportOptions
          updatedSWo={updatedSWo}
          setUpdatedSWo={setUpdatedSWo}
          selected={selected}
          setSelected={setSelected}
        />
      )}
      {loading && <Spinner />}

      {/* Show list of import statuses and loader according to their status */}
      {isImporting &&
        importStatuses.map((status) => (
          <div key={status.id} className="d-flex align-items-center gap-2 mb-2">
            {status.isCompleted ? (
              <span className="text-success">✔️</span>
            ) : (
              <Spinner animation="border" size="sm" />
            )}
            <span className="fs-5 fw-bold">{status.status}</span>
          </div>
        ))}
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={() => showModal(false)}>
          Close
        </button>
        <button className="btn btn-primary" onClick={handleImportSWo}>
          Import
        </button>
      </Modal.Footer>
    </div>
  );
}
